module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "game-content",
    on: {
      "contextmenu": function($event) {
        _vm.handler($event)
      }
    }
  }, [_c('game-header'), _vm._v(" "), _c('betting')], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-029cb006","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/Shop.vue
// module id = 395
// module chunks = 0